import React from 'react'
import { FaFacebookF,FaTwitter,FaInstagram } from "react-icons/fa";

import './Footer.css'

export default function Footer() {
    return (
        <div className="footer-container">

            <div className="copy-container">
                <div className="social-media">
                     <a href="https://www.facebook.com/"><FaFacebookF /></a>
                     <a href="https://twitter.com/"><FaTwitter/></a>
                     <a href="https://www.instagram.com/"><FaInstagram/></a>
                </div>

                <p>&copy; Copyright Ping. All rights reserved.</p>
            </div>

            <footer>
                <p>
                 Challenge by <a href="https://www.frontendmentor.io?solutions">Frontend Mentor</a>. Coded by
                    <a href="https://github.com/Pedro-Vitor-SG"> Pedro Vitor Silveira Gomes</a>.
               </p>
            </footer>

        </div>


    )
}